/**
 * URL utility functions for safe URL parsing and manipulation
 */

/**
 * Safely extracts hostname from a URL string
 * @param url - The URL string to parse
 * @returns Hostname if valid URL, otherwise returns the original string
 * @example
 * safeGetHostname('https://example.com/path') // 'example.com'
 * safeGetHostname('not-a-url') // 'not-a-url'
 */
export function safeGetHostname(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    // If URL parsing fails, return the original string as fallback
    return url;
  }
}

/**
 * Safely extracts hostname from a URL string and removes 'www.' prefix
 * @param url - The URL string to parse
 * @returns Domain without 'www.' if valid URL, otherwise returns the original string
 * @example
 * safeGetDomain('https://www.example.com/path') // 'example.com'
 * safeGetDomain('https://example.com/path') // 'example.com'
 * safeGetDomain('not-a-url') // 'not-a-url'
 */
export function safeGetDomain(url: string): string {
  try {
    return new URL(url).hostname.replace('www.', '');
  } catch {
    // If URL parsing fails, return the original string as fallback
    return url;
  }
}
